// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"37":"10c732c8","739":"0bd5a423","848":"8b43bffe"}[chunkId] + ".js";
};